import React, { useEffect, useState } from 'react'
import GoogleBarChart from '../../components/Charts/GoogleBarChart'
import ProfileCard from '../../components/Dashboard/profileCard'
import { v2_dashboard_stats } from '../../actions/v2/dashboard'
import LatestProjects from '../../components/Dashboard/latestProjects'
import moment from 'moment'
import LeaveRequests from '../../components/Dashboard/leaveRequests'
import MyPriorities from '../../components/Dashboard/myPriorities'
import NotificationFeed from '../../components/Dashboard/notificationFeed'

const ACCEPTED_REPORT_RECEIVED_STATUS = 'Accepted, Report received';

const STATUS_CONFIG = {
  fats: [
    'Unscheduled',
    'Scheduled',
    'Accepted with Comments',
    ACCEPTED_REPORT_RECEIVED_STATUS,
    'Not Applicable',
    'Cancelled',
  ],
  inspections: [
    'Unscheduled',
    'Scheduled',
    'In Progress',
    'Accepted',
    'Rejected',
    'Cancelled',
    'Re-Inspection',
  ],
};

const normalizeStatus = (moduleKey, status) => {
  const cleanStatus = String(status || '').replace(/_/g, ' ').trim();
  const normalizedStatus = cleanStatus.toLowerCase();

  if (cleanStatus === 'Approved Subjected to Comments') {
    return 'Approved With Comments';
  }

  if (moduleKey === 'inspections' && ['not mapped', 'not-mapped', 'not_mapped'].includes(normalizedStatus)) {
    return 'Rejected';
  }

  if (
    moduleKey === 'fats'
    && [
      'accepted',
      'accepted report received',
      'accepted report recieved',
      'accepted, report received',
      'accepted, report recieved',
    ].includes(normalizedStatus)
  ) {
    return ACCEPTED_REPORT_RECEIVED_STATUS;
  }

  return cleanStatus;
};

const buildStatusEntries = (moduleKey, statusSummary = {}) => {
  const configuredStatuses = STATUS_CONFIG[moduleKey] || [];
  const countMap = configuredStatuses.reduce((acc, status) => {
    acc[status] = 0;
    return acc;
  }, {});

  Object.entries(statusSummary)
    .filter(([status]) => status !== 'Total')
    .forEach(([status, count]) => {
      const mappedStatus = normalizeStatus(moduleKey, status);
      countMap[mappedStatus] = Number(countMap[mappedStatus] || 0) + Number(count || 0);
    });

  return [
    ...configuredStatuses.map((status) => [status, countMap[status] || 0]),
    ...Object.entries(countMap).filter(([status]) => !configuredStatuses.includes(status)),
  ];
};

const Index = (props) => {
  const [stats, setStats] = useState(null);
  const [cards, setCards] = useState([
    { key: 'planApprovals', label: 'Plan Approvals', count: '' },
    { key: 'fats', label: 'FATs', count: '' },
    { key: 'ncrs', label: 'NCRs', count: '' },
    { key: 'inspections', label: 'Inspections', count: '' },
  ]);

  const [activeCardKey, setActiveCardKey] = useState('planApprovals'); // default active

  useEffect(() => {
    v2_dashboard_stats().then((res) => {
      const result = res.result;
      console.log(result);
      
      setStats(result);

      const summaryMap = {
        planApprovals: result.planStatusSummary?.Total || 0,
        fats: result.fatStatusSummary?.Total || 0,
        ncrs: result.ncrStatusSummary?.Total || 0,
        inspections: result.inspectionStatusSummary?.Total || 0,
      };

      const updated = cards.map(card => ({
        ...card,
        count: summaryMap[card.key] ?? 0
      }));

      setCards(updated);
    });
  }, []);


  const getStatusSummary = () => {
    if (activeCardKey === 'planApprovals') return stats?.planStatusSummary || {};
    if (activeCardKey === 'fats') return stats?.fatStatusSummary || {};
    if (activeCardKey === 'ncrs') return stats?.ncrStatusSummary || {};
    if (activeCardKey === 'inspections') return stats?.inspectionStatusSummary || {};
    return {};
  };


  const statusSummary = getStatusSummary();
  const statusEntries = buildStatusEntries(activeCardKey, statusSummary);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          {/* start page title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">
                  NEW-BUILDING SHIP SITE MANAGEMENT CONTROL PANEL
                </h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active">&gt;&gt; Dashboard</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* end page title */}
          <div className="row">
            <div className="col-xl-4">
              <ProfileCard />
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title mb-2">Monthly Stats [ {moment().format('MMM YY')} ]</h4>
                  <div className="row" style={{ marginBottom: '-5px' }}>
                    <div className="col-sm-6">
                      <div className='monthly-stats-box'>
                        <div className='monthly-first' style={{ width: '150px' }}>
                          <p
                            className="text-muted"
                            style={{ marginBottom: 5, fontSize: 14, fontWeight: 600 }}
                          >
                            Projects Created
                          </p>

                        </div>
                        <div className="monthly-second">
                          <span className="badge rounded-pill float-end"
                            style={{ backgroundColor: 'rgb(43, 90, 126)', color: 'rgb(255, 255, 255)' }}
                          >{stats?.projectsCreatedCurrenMonth}</span>

                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className='monthly-stats-box'>
                        <div className='monthly-first' style={{ width: '150px' }}>
                          <p
                            className="text-muted"
                            style={{ marginBottom: 5, fontSize: 14, fontWeight: 600 }}
                          >
                            Ships Delivered
                          </p>
                        </div>
                        <div className="monthly-second">
                          <span className="badge rounded-pill float-end"
                            style={{ backgroundColor: 'rgb(43, 90, 126)', color: 'rgb(255, 255, 255)' }}
                          >{stats?.shipsDeliveredCurrenMonth}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row">
                <div className="col-md-4">
                  <div className="card mini-stats-wid main-stats">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Projects</p>
                          <h4 className="mb-0">{stats?.totalProject}</h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
                            <span
                              className="avatar-title iship-custom-bg"
                            >
                              <i className="bx bx-list-check font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card mini-stats-wid main-stats">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Ship Owners</p>
                          <h4 className="mb-0">{stats?.totalShipOwner}</h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="avatar-sm rounded-circle bg-primary mini-stat-icon">
                            <span
                              className="avatar-title rounded-circle bg-primary iship-custom-bg"

                            >
                              <i className="bx bxs-user-circle font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card mini-stats-wid main-stats">
                    <div className="card-body">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Ships</p>
                          <h4 className="mb-0">{stats?.totalShips}</h4>
                        </div>
                        <div className="flex-shrink-0 align-self-center">
                          <div className="avatar-sm rounded-circle bg-primary mini-stat-icon">
                            <span
                              className="avatar-title rounded-circle bg-primary iship-custom-bg"
                            >
                              <i className="fa fa-ship font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>


              <div className="row">
                {cards.map(card => (
                  <div
                    key={card.key}
                    className={`col-md-3 ${activeCardKey === card.key ? 'active' : ''}`}
                    onClick={() => setActiveCardKey(card.key)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="d-flex dash-flex align-items-center">
                          <div className="flex-grow-1 flex-grow-para">
                            <p className="text-muted fw-medium">{card.label}</p>
                          </div>
                          <div>
                            <h4 className="mb-0">{card.count}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-3">
                {statusEntries.map(([status, count]) => (
                  <div className="col" key={status}>
                    <div className="card mini-stats-wid">
                      <div className="card-body">
                        <div className="d-flex dash-flex align-items-center">
                          <div className="flex-grow-1 flex-grow-para">
                            <p className="text-muted fw-medium">{status.replace(/_/g, ' ')}</p>
                          </div>
                          <div>
                            <h4 className="mb-0">{count}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* end row */}

            </div>
          </div>
          {/* end row */}
          <div className='row'>
            <div className='col-lg-7'>
              <GoogleBarChart
                data={stats?.chartData}

              />
            </div>
            <div className='col-lg-5'>
              <MyPriorities />
              <div className="mt-3">
                <NotificationFeed />
              </div>
            </div>
          </div>
          {<LatestProjects />}
          {/* end row */}
          {/* end row */}
          {<LeaveRequests />}
          {/* end row */}
          {/* end row */}
        </div>{" "}
        {/* container-fluid */}
      </div>

    </React.Fragment>

  )
}

export default Index
